export default "skymp5-front/42c6bb94b6d183c0b0d57104391b6d9b.png";